"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOauthStateString = void 0;
/**
 * OauthのStateを生成する
 * @param isDesktop
 * @param refType
 * @param refValue
 * @param redirectTo
 * @returns
 */
const buildOauthStateString = (isDesktop, refType, refValue, redirectTo = undefined) => {
    const state = redirectTo
        ? {
            refDevice: isDesktop ? 'pc' : 'mobile',
            refType: refType !== null && refType !== void 0 ? refType : null,
            refValue: refValue !== null && refValue !== void 0 ? refValue : null,
            redirectTo
        }
        : {
            refDevice: isDesktop ? 'pc' : 'mobile',
            refType: refType !== null && refType !== void 0 ? refType : null,
            refValue: refValue !== null && refValue !== void 0 ? refValue : null
        };
    return JSON.stringify(state);
};
exports.buildOauthStateString = buildOauthStateString;
//# sourceMappingURL=buildOauthState.js.map